import { graphql } from 'gatsby';
import get from 'lodash/get';
import React from 'react';

import { RichText } from './RichText';
import { root } from './RichTextCenteredText.module.scss';

const RichTextCenteredText: React.FC<{
  node: { data: { target: Queries.RichTextCenteredTextFragment } };
}> = ({ node }) => {
  const entry = get(node, 'data.target');

  if (!entry) {
    console.warn('[RichTextCenteredText] Entry not rendered', { node });
    return null;
  }

  return (
    <div className={root}>
      <RichText content={node.data.target.content} />
    </div>
  );
};

export default RichTextCenteredText;

export const query = graphql`
  fragment RichTextCenteredText on ContentfulComponentCenteredText {
    __typename
    contentful_id
    content {
      raw
      references {
        # ... on ContentfulProductVariant {
        #   __typename
        #   contentful_id
        #   slug
        # }
        ... on ContentfulPage {
          __typename
          contentful_id
          slug
        }
      }
    }
  }
`;
